import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25.988}
    height={13.886}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 50770 27127"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#2b2a29;stroke-width:562.638}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974325604480">
        <path
          d="M15519 2849h-1c-41 1146-1067 2051-2280 2012L2412 4509C1198 4470 240 3500 282 2355 323 1209 1350 304 2564 343l10826 353c1212 39 2170 1008 2129 2153zM25421 481l-8469 198c118 4202 3874 7552 8469 7552 4678 0 8470-3469 8470-7750h-8470zM50488 2789c-42 1145-1068 2050-2281 2011l-10826-353c-1213-38-2171-1008-2129-2153 41-1146 1068-2051 2281-2012l10826 352c1213 39 2171 1009 2129 2155zM25281 26846c1215 0 2207-937 2207-2084V14531c0-1147-992-2084-2207-2084-1214 0-2206 937-2206 2084v10231c0 1147 992 2084 2206 2084zM42482 19518h1c883-786 924-2111 91-2946l-7432-7443c-831-834-2236-873-3118-86-883 785-925 2112-92 2945l7431 7444c832 834 2236 873 3119 86zM17996 9783c-855-813-2259-819-3121-11l-7688 7208c-861 807-866 2134-12 2946v1c856 814 2260 818 3121 11l7688-7208c861-808 867-2134 12-2947z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
